export default {
    eyebrow: "Contacto",
    title: "Cuentanos que necesitas",
    description: "Solicita una demo o envia una consulta general. Nuestro equipo te respondera' pronto.",
    backToLanding: "Volver a la landing",
    help: {
        title: "Respuesta rapida",
        description: "Revisamos cada solicitud y respondemos lo antes posible.",
    },
    fields: {
        fullName: {
            label: "Nombre completo",
            placeholder: "Tu nombre y apellido",
            hint: "Usa tu nombre real para facilitar el seguimiento.",
        },
        workEmail: {
            label: "Email corporativo",
            placeholder: "nombre@empresa.com",
            hint: "Usa una direccion de email de empresa.",
        },
        company: {
            label: "Empresa",
            placeholder: "Nombre de tu empresa",
            hint: "La empresa que representas.",
        },
        requestType: {
            label: "Tipo de solicitud",
            options: {
                demo: "Solicitar una demo",
                general: "Consulta general",
            },
        },
        relationshipType: {
            label: "Tu rol (opcional)",
            placeholder: "Selecciona tu rol",
            options: {
                shipper: "Shipper",
                receiver: "Receiver",
                notify_party: "Notify party",
                freight_forwarder: "Freight forwarder",
                carrier: "Carrier",
                customs_broker: "Customs broker",
                port_authority: "Port authority",
                insurance_provider: "Insurance provider",
                inspection_agency: "Inspection agency",
                regulatory_authority: "Regulatory authority",
                land_transport: "Land transport",
                supplier: "Proveedor",
                customer: "Cliente",
                other: "Otro",
            },
        },
        message: {
            label: "Mensaje",
            placeholder: "Comparte contexto, objetivos o preguntas...",
            hint: "Maximo 2000 caracteres.",
        },
        privacyConsent: {
            label: "Acepto el tratamiento de mis datos para fines de contacto.",
            hint: "Obligatorio para enviar este formulario.",
        },
    },
    validation: {
        fullNameRequired: "El nombre completo es obligatorio.",
        workEmailRequired: "El email corporativo es obligatorio.",
        workEmailInvalid: "Introduce un email valido.",
        companyRequired: "La empresa es obligatoria.",
        messageRequired: "El mensaje es obligatorio.",
        messageTooLong: "El mensaje debe tener como maximo 2000 caracteres.",
        privacyConsentRequired: "Debes aceptar el consentimiento de privacidad para continuar.",
    },
    submit: {
        cta: "Enviar solicitud",
        successTitle: "Solicitud enviada",
        successDescription: "Gracias. Hemos recibido tu solicitud y te contactaremos pronto.",
        successToast: "Solicitud de contacto enviada correctamente.",
        backHome: "Ir a la landing",
    },
};
